module.exports = __webpack_public_path__ + "media/images/svg/lines-5a7ee496c5f2973b261b7bad2324585b.svg";